<template>
    <div class="btn-group btn-group-toggle" :class="{'disabled': disabled}">
        <btn v-for="(option, index) in options" :key="index" class="btn btn-outline-light" :disabled="disabled"
             :class="{'active': (typeof option === 'object' && value === option.value) || value === option}"
             @click="selectOption(option)">
            <span class="me-1" v-if="typeof option === 'object' && option.icon"><img :src="option.icon" :alt="option.label"></span>
            {{ typeof option === 'object' ? option.label : option }}
        </btn>
    </div>
</template>

<script>

export default {
    name: 'BtnGroupToggle',
    props: {
        options: {
            default: [],
        },
        value: {
            default: null,
        },
        disabled: {
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        selectOption(option) {
            if (typeof option === 'object') {
                if (option.value === this.value) {
                   //TODO deselect value
                } else {
                    this.$emit('input', option.value);
                }
            } else {
                this.$emit('input', option);
            }
        },
    },
};
</script>
